import {Component, Input, OnInit} from '@angular/core';
import {textSubstring} from "../../../../shared/utils/utils.functions";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-user-candidature',
  templateUrl: './user-candidature.component.html',
  styleUrl: './user-candidature.component.scss'
})
export class UserCandidatureComponent implements OnInit{
  @Input() data: any;
  @Input() column: any; // Define input property for 'column'

  constructor( ) {
  }
  ngOnInit() {
  }

  protected readonly textSubstring = textSubstring;
  protected readonly environment = environment;
}
